const isInteractiveElement = (el) => {
  if (!el) return false;
  return Boolean(
    el.closest(
      'a, button, input, select, textarea, label, [role="button"], .map_container, #leaflet_map, .leaflet-container'
    )
  );
};

const initStepSwipeNavigation = () => {
  const root = document.querySelector('.map-page-main');
  if (!root) return;

  const nextLink = document.querySelector('[data-step-nav="next"]');
  const prevLink = document.querySelector('[data-step-nav="prev"]');
  if (!nextLink && !prevLink) return;

  let startX = 0;
  let startY = 0;
  let startTime = 0;
  let swipeEnabled = false;

  root.addEventListener(
    'touchstart',
    (event) => {
      if (window.innerWidth > 991) return;
      if (!event.touches || event.touches.length !== 1) return;
      if (isInteractiveElement(event.target)) return;

      const touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      startTime = Date.now();
      swipeEnabled = true;
    },
    { passive: true }
  );

  root.addEventListener(
    'touchend',
    (event) => {
      if (!swipeEnabled) return;
      swipeEnabled = false;
      if (!event.changedTouches || !event.changedTouches.length) return;

      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - startX;
      const deltaY = touch.clientY - startY;
      const elapsed = Date.now() - startTime;
      const absX = Math.abs(deltaX);
      const absY = Math.abs(deltaY);

      const isHorizontalSwipe = absX >= 80 && absX > absY * 1.25 && elapsed < 900;
      if (!isHorizontalSwipe) return;

      if (deltaX < 0 && nextLink) {
        window.location.assign(nextLink.href);
        return;
      }

      if (deltaX > 0 && prevLink) {
        window.location.assign(prevLink.href);
      }
    },
    { passive: true }
  );
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStepSwipeNavigation);
} else {
  initStepSwipeNavigation();
}
